<script setup lang="ts">
type Emit = {
  (event: 'update:modelValue', value: string): void
}

interface Props {
  modelValue?: string
}

const emit = defineEmits<Emit>()

const props = withDefaults(defineProps<Props>(), {
  modelValue: ''
})

const unformattedValue = ref(props.modelValue || '')

const formatPhoneNumber = (phone: string): string => {
  const cleaned = phone.replace(/\D/g, '').substring(0, 10)

  return cleaned.length > 0
    ? `(${cleaned.substring(0, 3)}` +
        (cleaned.length > 3 ? `) ${cleaned.substring(3, 6)}` : '') +
        (cleaned.length > 6 ? `-${cleaned.substring(6)}` : '')
    : ''
}

const updateValue = (rawValue: string) => {
  const numericValue = rawValue.replace(/\D/g, '').substring(0, 10)
  unformattedValue.value = numericValue
  emit('update:modelValue', numericValue)
}

const handlePaste = (event: ClipboardEvent) => {
  const pastedData = event.clipboardData?.getData('text') || ''
  updateValue(pastedData)
  event.preventDefault()
}

const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  updateValue(target.value)
  target.value = formatPhoneNumber(unformattedValue.value)
}

const value = computed({
  get() {
    if (props.modelValue) {
      return formatPhoneNumber(props.modelValue)
    }
    return formatPhoneNumber(unformattedValue.value)
  },
  set(val) {
    updateValue(val)
  }
})

watch(
  () => props.modelValue,
  (val) => {
    unformattedValue.value = val || ''
  }
)
</script>

<template>
  <UIFormInput
    v-model="value"
    autocomplete="tel"
    variant="outlined"
    placeholder="(     )"
    @paste="handlePaste"
    @input="handleInput"
  />
</template>
